import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const EmptyPortfolioPreviewState = ({ onCreateAlbum, readOnly = false }) => {
  return (
    <Box sx={{ p: 0 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Portfolio
      </Typography>
      <Box sx={{ position: "relative", height: "250px", overflow: "hidden", borderRadius: 2, border: "1px solid #E5E7EB" }}>
        {/* Background Image */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("/assets/images/profile_portfolio_cover.png")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: 1,
          }}
        />
        
        {/* Dark overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2,
          }}
        />
        
        {/* Centered content. The absolute box needs an explicit width, or the
            34px h4 headline widens past the 375px frame. */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            px: 2,
            boxSizing: "border-box",
            textAlign: "center",
            zIndex: 3,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 600,
              mb: 1,
              color: "#4D6BF6",
              fontSize: { xs: "20px", sm: "28px", md: "34px" },
            }}
          >
            Showcase your work
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              mb: { xs: 2, md: 3 },
              color: "black",
              fontSize: { xs: "15px", sm: "20px", md: "24px" },
              letterSpacing: 0,
            }}
          >
            to attract potential clients
          </Typography>
          {!readOnly && onCreateAlbum && (
            <Button
              variant="outlined"
              onClick={onCreateAlbum}
              sx={{
                backgroundColor: "white",
                border: "1px solid #D1D5DB",
                borderRadius: 2,
                textTransform: "none",
                px: { xs: 2.5, md: 4 },
                py: 1.5,
                fontSize: { xs: "14px", md: "16px" },
                fontWeight: 600,
                color: "black",
                "&:hover": {
                  backgroundColor: "#F9FAFB",
                  border: "1px solid #D1D5DB",
                },
              }}
            >
              Upload your portfolio
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EmptyPortfolioPreviewState;
